import { useEffect, useContext, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { DataContext } from 'providers/data';
import { ParamsPageWebView, ParamsDataListaCotacaoAddService } from 'utils/typeServices';

import { Typography, Box } from '@mui/material';
import NavSubPage from 'components/views/NavSubPage';
import CircularProgress from '@mui/material/CircularProgress';

import Modals from 'components/views/Modals';
import ParseWebView from 'components/views/ParseWebView';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';
import { ContentBodyPage, ContentNewsPage } from 'components/views/ContainersPage';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as IcDeleted } from 'assets/icons/ic-deleted.svg';
import { ReactComponent as IcIturanCheck } from 'assets/icons/ic-ituran-check.svg';

type ParamsStyle = {
    theme?: Theme;
}

export const GridTab = styled(Box)(
    ({ theme }: ParamsStyle) => `
    display: grid;
    grid-template-columns: 50% 43% 7%;

    p {
        font-size: .75rem;
        line-height: 1rem;
        color: ${theme?.palette.grey[400]};
    }

    h6 {
        font-size: .875rem;
        line-height: 1.2;
        align-items: flex-end;
        color: ${theme?.palette.primary.main};
    }
`);

const AddServicesInProgress = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const [itemSelected, setItemSelected] = useState(0);
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);
    const [isLoadingDeleted, setIsLoadingDeleted] = useState(false);
    const [showOptionDeleted, setShowOptionDeleted] = useState(false);
    const [showModalNotExist, setShowModalNotExist] = useState(false);
    const [showModalDeleted, setShowModalDeleted] = useState({ show: false, cD_COTACAO: 0, cD_PESSOA: 0 });
    const [dataListaCotacaoAddServiceState, setDataListaCotacaoAddServiceState] = useState<Array<ParamsDataListaCotacaoAddService>>();
    const { selectedCar, dataPostCancelChange, dataListaCotacaoAddService, customerCars, handlePostGetStatusAddService, handlePostCancelChange, handleGetListaCotacaoAddService, handleSelectedCar } = useContext(DataContext);

    const handlePostCancelChangeState = () => {
        setIsLoadingDeleted(true);
        setItemSelected(showModalDeleted.cD_COTACAO);
        handlePostCancelChange({ cD_COTACAO: showModalDeleted.cD_COTACAO, cD_PESSOA: showModalDeleted.cD_PESSOA });
    }

    const handleSwitchTypeQuotation = (NR_TIPO_COTACAO: number) => {
        switch (NR_TIPO_COTACAO) {
            case 3:
                return 'Troca de serviço';
            case 4:
                return 'Troca de veículo';
            case 5:
                return 'Troca de Equipamento';
            case 7:
                return 'Serviço adicional';
        }
    }

    const handlePostGetStatusState = (cD_PEDIDO: number, cD_COTACAO: number, NR_PLATAFORMA_ORIGEM: number, GUID_COTACAO: string) => {
        if (selectedCar) {
            setIsLoadingStatus(true);
            const carSelected = customerCars.find(({ NR_PLATAFORMA }) => NR_PLATAFORMA === NR_PLATAFORMA_ORIGEM);

            if (carSelected) {
                handleSelectedCar(carSelected);

                setItemSelected(cD_COTACAO);
                handlePostGetStatusAddService({ body: { cD_PEDIDO: cD_PEDIDO, customerId: selectedCar?.CD_PESSOA, GUID_COTACAO: GUID_COTACAO }, isWebView, nrPlatform: carSelected.NR_PLATAFORMA });
            }
        }
    }

    useEffect(() => {
        if ((typeof dataListaCotacaoAddService === 'undefined') && selectedCar) {
            handleGetListaCotacaoAddService(selectedCar.NR_CNPJ_CPF);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar]);

    useEffect(() => {
        if (Array.isArray(dataListaCotacaoAddService)) {
            let dataListaCotacaoAddServiceAux: Array<ParamsDataListaCotacaoAddService> = [];
            let dataListaCotacaoAddServiceAuxListWipe: Array<ParamsDataListaCotacaoAddService> = [];

            dataListaCotacaoAddService.map((value) => (dataListaCotacaoAddServiceAux?.findIndex(({ NR_PLATAFORMA_ORIGEM }) => NR_PLATAFORMA_ORIGEM === value.NR_PLATAFORMA_ORIGEM) === -1) && dataListaCotacaoAddServiceAux.push(value));

            // eslint-disable-next-line array-callback-return
            dataListaCotacaoAddServiceAux.map(({ NR_PLATAFORMA_ORIGEM }) => {
                const filterAux = dataListaCotacaoAddService.filter(({ NR_PLATAFORMA_ORIGEM: NR_PLATAFORMA_ORIGEM_LIST, NR_TIPO_COTACAO, STATUS_PEDIDO_COTACAO }) => ((NR_TIPO_COTACAO === 7) && (NR_PLATAFORMA_ORIGEM_LIST === NR_PLATAFORMA_ORIGEM) && (STATUS_PEDIDO_COTACAO <= 5)));

                if (filterAux?.length > 0) {
                    let max = filterAux.reduce((a, b) => {
                        return new Date(a.DT_COTACAO).getTime() > new Date(b.DT_COTACAO).getTime() ? a : b;
                    });

                    dataListaCotacaoAddServiceAuxListWipe.push(max);
                }
            });

            dataListaCotacaoAddServiceAux.length > 0 ? setDataListaCotacaoAddServiceState(dataListaCotacaoAddServiceAuxListWipe) : setDataListaCotacaoAddServiceState(undefined);
        } else if (dataListaCotacaoAddService === false) {
            setDataListaCotacaoAddServiceState(undefined);
            setShowModalNotExist(true);
        }
    }, [dataListaCotacaoAddService]);

    useEffect(() => {
        if (dataListaCotacaoAddService !== undefined) {
            setItemSelected(0);
            setIsLoadingStatus(false);
            setIsLoadingDeleted(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataListaCotacaoAddService]);

    useEffect(() => {
        if (dataPostCancelChange !== undefined) {
            if (selectedCar) {
                handleGetListaCotacaoAddService(selectedCar.NR_CNPJ_CPF);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataPostCancelChange]);

    return (
        <ParseWebView isWebView={isWebView} typePage='page'>
            <ContentBodyPage>
                <NavSubPage title='Contratação em andamento' link={isWebView ? '/wb/servicos-adicionais' : '/servicos-adicionais'} />
                <Box sx={{ marginBottom: '2.8125rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IcIturanCheck />
                    <Typography fontSize='1.125rem'>
                        <strong>Escolha</strong> a contratação que deseja finalizar:
                    </Typography>
                </Box>

                <Box sx={{ paddingRight: { xs: '0', md: '2.5rem' } }}>
                    <GridTab sx={{ borderBottom: '1px solid rgba(141, 155, 181, 0.35)', position: 'relative' }}>
                        <p>Tipo</p>
                        <p>Placa</p>
                        <p />
                        <Box sx={{ position: 'absolute', right: '0', bottom: '.69rem', 'button': { width: '5rem', borderRadius: '6.25rem', fontWeight: '600', height: '1.5625rem', fontSize: '.75rem' } }}>
                            <ButtonOutlined name={showOptionDeleted ? 'FINALIZAR' : 'EXCLUIR'} onClick={() => setShowOptionDeleted(!showOptionDeleted)} />
                        </Box>
                    </GridTab>
                    {dataListaCotacaoAddServiceState?.map(({ DS_PLACA, CD_COTACAO, NR_TIPO_COTACAO, CD_PESSOA_ORIGEM, STATUS_PEDIDO_COTACAO, NR_PLATAFORMA_ORIGEM, GUID_COTACAO }, index) =>
                        <Box sx={{ display: 'grid', gridTemplateColumns: showOptionDeleted ? 'auto 4rem' : '1fr' }} key={index}>
                            <GridTab
                                key={index}
                                sx={{
                                    padding: '1.31rem 0 1.18rem',
                                    borderBottom: '1px solid #8D9BB5',
                                    opacity: (isLoadingDeleted || isLoadingStatus) ? '.5' : '1',
                                    cursor: (isLoadingDeleted || isLoadingStatus) ? 'not-allowed' : 'pointer',
                                    ":hover": {
                                        backgroundColor: 'rgba(16, 167, 224, 0.1)'
                                    }
                                }} onClick={() => (!isLoadingDeleted && !isLoadingStatus) && handlePostGetStatusState(0, CD_COTACAO, NR_PLATAFORMA_ORIGEM, GUID_COTACAO)}>
                                <h6>{handleSwitchTypeQuotation(NR_TIPO_COTACAO)}</h6>
                                <h6 style={{ paddingLeft: showOptionDeleted ? '2rem' : '0' }}>
                                    {DS_PLACA}
                                </h6>
                                <Box sx={{ height: '1.25rem', marginTop: '-2px' }}>
                                    {(isLoadingStatus && (itemSelected === CD_COTACAO)) ?
                                        <CircularProgress sx={{ maxWidth: '1.25rem', maxHeight: '1.25rem' }} />
                                        :
                                        <ArrowForwardIosIcon fontSize='small' />
                                    }
                                </Box>
                            </GridTab>
                            {showOptionDeleted &&
                                <Box sx={{
                                    borderLeft: '1px solid #8D9BB5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '.45rem 0',
                                    opacity: (isLoadingDeleted || isLoadingStatus) ? '.5' : '1'
                                }}>
                                    {(isLoadingDeleted && (itemSelected === CD_COTACAO)) ?
                                        <CircularProgress sx={{ maxWidth: '1.75rem', maxHeight: '1.75rem' }} />
                                        :
                                        <IcDeleted
                                            onClick={() => (!isLoadingDeleted && !isLoadingStatus && (STATUS_PEDIDO_COTACAO !== 5)) && setShowModalDeleted({ show: true, cD_COTACAO: CD_COTACAO, cD_PESSOA: CD_PESSOA_ORIGEM })}
                                            style={{ cursor: (isLoadingDeleted || isLoadingStatus || (STATUS_PEDIDO_COTACAO === 5)) ? 'not-allowed' : 'pointer' }} />
                                    }
                                </Box>
                            }
                        </Box>
                    )}
                </Box>
            </ContentBodyPage>

            <ContentNewsPage>
                <Box sx={{
                    display: { xs: 'none', md: 'block' },
                    width: '100%',
                    height: 'calc(100vh - 6.5rem)',
                    backgroundColor: '#EFF2F5',
                    borderTop: '1px solid rgba(141, 155, 181, 0.5)',
                    marginTop: '33.2px'
                }}
                />
            </ContentNewsPage>

            <Modals open={showModalDeleted.show}>
                <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            ATENÇÃO!
                        </Typography>
                        <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                            Tem certeza que deseja excluir esta<br />
                            contratação em andamento?
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.875rem 3.81rem 1.75rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <ButtonRectangle name='EXCLUIR' onClick={() => { setShowModalDeleted({ show: false, cD_COTACAO: 0, cD_PESSOA: 0 }); handlePostCancelChangeState() }} />
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined name='CANCELAR' onClick={() => setShowModalDeleted({ show: false, cD_COTACAO: 0, cD_PESSOA: 0 })} />
                        </Box>
                    </Box>
                </Box>
            </Modals>

            <Modals open={showModalNotExist}>
                <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            ATENÇÃO!
                        </Typography>
                        <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                            Não existe contratação em andamento.
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.875rem 3.81rem 1.75rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined name='Voltar' onClick={() => { setShowModalNotExist(false); navigate('/servicos-adicionais') }} />
                        </Box>
                    </Box>
                </Box>
            </Modals>
        </ParseWebView>
    );
}

export default AddServicesInProgress;